import { Component, OnInit, ViewChild } from '@angular/core';
import { Persona } from 'src/app/models/Persona';
import { ExternosService } from 'src/app/services/externos/externos.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalEmpresaComponent } from '../modal-involucrada/modal-empresa/modal-empresa.component';
import { openModalMensaje, iconEliminar, DscTituloPaginator, strDscMsjPrgEliminar, openModalMensajePrg, iconAgregar, iconVer, isNotEmptyList, isEmptyList, strMatTablePaginator, modificarTamañoModal} from 'src/app/general/variables';
import { Fur } from 'src/app/models/Fur';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { ModalDatosEmpresaComponent } from '../modal-datos-empresa/modal-datos-empresa.component';
import { Denunciante } from 'src/app/models/Denunciante';
import { PersonaXRepLeg } from 'src/app/models/PersonaXRepLeg';
import { ModalVerRepreLegalComponent } from '../modal-ver-repre-legal/modal-ver-repre-legal.component';


@Component({
  selector: 'app-empresa-involucrada',
  templateUrl: './empresa-involucrada.component.html',
  styleUrls: ['./empresa-involucrada.component.css']
})
export class EmpresaInvolucradaComponent implements OnInit {
  // Icono
  iconoEliminar = iconEliminar;
  //

  dataSource: MatTableDataSource<Persona>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  flgLectura = false;
  matTableColumnsDef = ['item', 'ruc', 'razonSocial', 'direccion', 'acciones']; //
  matTableColumnsEtiq = ['Ítem', 'RUC', 'Razón Social', 'Dirección', 'Eliminar']; //'Representante',
  strMatTablePaginator = strMatTablePaginator;
  empresaList: Persona[] = [];
  cbk_ruc = true;
  cbk_empresa = 'RUC';
  strDscTitulo = 'Empresa(s) involucrada(s)';
  inputRuc: string;
  inputRazonSocial: string;
  empresa_registrada  = false;
  flgRucDisabled = false;
  flgRazonSocialDisabled = true;
  flgDeshabilitaValidar = false;
  flgConoceEmpresa = false;
  iconAgregar = iconAgregar;
  iconVer = iconVer;
  isNotEmptyList = isNotEmptyList;
  isEmptyList = isEmptyList;
  // dscTextoValidar = DscEtiquetaBtnVal;

 /* formEmpresaInvolucrada = new FormGroup({
    input_ruc: new FormControl(''),
    input_razon_social : new FormControl(''),
    flg_empresa_registrada : new FormControl(''),
    cbk_empresa : new FormControl('RUC'),
    empresa_registrada  : new FormControl(false)

  });*/
  constructor(private externoService: ExternosService, public dialog: MatDialog) { }



  ngOnInit() {



  }

  _verRepresentate(listaData: PersonaXRepLeg[]) {

    const configuracionGlobal = new MatDialogConfig();
    configuracionGlobal.disableClose = false;
    configuracionGlobal.autoFocus = true;
    configuracionGlobal.data = {
      listPersonaXRL : listaData
    };
    configuracionGlobal.width = '90%';
    // configuracionGlobal = modificarTamañoModal(configuracionGlobal);
    configuracionGlobal.maxHeight = 600;
    this.dialog.open(ModalVerRepreLegalComponent, configuracionGlobal);

  }


  obtenerEmpresa() {

      console.log('========Obtener Empresa');




      const isRuc = this.cbk_empresa; // this.formEmpresaInvolucrada.get('cbk_empresa').value;
      let valorInput = this.inputRazonSocial;
      let resultado ;
      let persona = new Persona();

      if (isRuc == 'RAZON_SOCIAL' ) {
        /// Refactorizar codigo
          if (valorInput != '') {// this.formEmpresaInvolucrada.get('input_razon_social').value

          // this.dscTextoValidar = DscEtiquetaBtnVal;
          this.flgDeshabilitaValidar = true;
          // valorInput = //this.formEmpresaInvolucrada.get('input_razon_social').value;
          this.externoService.obtenerEmpresaXRazonSocial(valorInput).subscribe(data => {

                resultado  = JSON.parse(JSON.stringify(data));
               // if(resultado.listaRetorno != null){ //Validación del servicio anterior
                if (resultado.ruc != null) {
                  // persona = this.cargarDatosPersona(resultado.listaRetorno[0]);
                  persona = this.cargarDatosPersona(resultado);
                  this.abrirModal(persona, true, this.empresaList);

                } else {
                  openModalMensaje('No se encontró datos de la razón social', 'Debe ingresar una razón social valida', this.dialog);
                }
                /*this.dialog.open(ModalEmpresaComponent,{width:'60%',data:{cpersonaNroDoc:persona.cpersonaNroDoc,
                  cpersonaRazonsocial:persona.cpersonaRazonsocial,flgValida:true,listaEmpresa: this.empresaList}});*/

                  // this.dscTextoValidar = DscEtiquetaBtnVal2;

                this.flgDeshabilitaValidar = false;

               }, err => {

                  openModalMensaje('No se encontró datos de la razón social', 'Debe ingresar una razón social valida', this.dialog);

                  console.log(err);
                  this.flgDeshabilitaValidar = false;

                  // openModalMensaje('Empresa Involucrada','Debe ingresar una razón social',this.dialog);


               });



          } else {
            // this.flgDeshabilitaValidar = false;
            openModalMensaje('Empresa Involucrada', 'Debe ingresar una razón social', this.dialog);
          }

      } else {

        if (this.inputRuc != '') { // this.formEmpresaInvolucrada.get('input_ruc').value

          if (this.inputRuc.length < 11) { // this.formEmpresaInvolucrada.get('input_ruc').value.length

            // this.flgDeshabilitaValidar = false;

            openModalMensaje('Empresa Involucrada', 'Debe ingresar un ruc válido', this.dialog);

          } else {

            valorInput = this.inputRuc; // this.formEmpresaInvolucrada.get('input_ruc').value;

            // this.dscTextoValidar = DscEtiquetaBtnVal;

            this.flgDeshabilitaValidar = true;

            this.externoService.obtenerEmpresaXRUC(valorInput).subscribe(data => {
                resultado = JSON.parse(JSON.stringify(data));
                // if(resultado.listaRetorno != null){ //El servicio anterior validaba esto ahora siempre devuelve null
                if (resultado.ruc != null) {
                 // persona = this.cargarDatosPersona(resultado.listaRetorno[0]);
                 persona = this.cargarDatosPersona(resultado);
                 this.abrirModal(persona, true, this.empresaList);
                } else {
                  openModalMensaje('No se encontró datos del RUC', 'Debe ingresar un ruc válido', this.dialog);
                }

                this.flgDeshabilitaValidar = false;

                // this.dscTextoValidar = DscEtiquetaBtnVal2;

                /*this.dialog.open(ModalEmpresaComponent,{width:'60%',data:{cpersonaNroDoc:persona.cpersonaNroDoc,
                  cpersonaRazonsocial:persona.cpersonaRazonsocial,flgValida:true,listaEmpresa: this.empresaList}});*/
            }, err => {

              this.flgDeshabilitaValidar = false;

              openModalMensaje('Empresa Involucrada', 'El servicio de SUNAT no se encuentra disponible de momento', this.dialog);

              console.log(err);

            });

          }

        } else {
          // this.flgDeshabilitaValidar = false;
          openModalMensaje('Empresa Involucrada', 'Debe ingresar un ruc', this.dialog);

        }

      }

  }

  cargarDatosPersona(resultado) {
    console.log(resultado);
    const persona = new Persona();
    persona.cpersonaNrodoc = resultado.ruc;
    persona.cpersonaRazonsocial = resultado.razon_Social;
     // persona.cpersonaRazonsocial = resultado.nombre;

      // Faltaría agregar campo dirección y representante legal
    persona.cpersonaDscreprelegal = resultado.representante;
    persona.cpersonaDscdireccion = resultado.domicilio_Legal;
    return persona;
  }

  _abrirModalEmpresa() {

    const configuracionGlobal = new MatDialogConfig();
    let vDenunciante: Denunciante = null;
    let vPersona: Persona = null;
    let vPersonaXRL: PersonaXRepLeg = null;
    const vListEmpresas = JSON.parse( JSON.stringify( this.empresaList ) );
    let dscRepre: string = null;

    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;

    configuracionGlobal.data = {

      listaEmpresa: vListEmpresas
    };

    configuracionGlobal.width = '80%';
    configuracionGlobal.height = '80%';
    // configuracionGlobal.maxHeight = 600;

    const  modal = this.dialog.open(ModalDatosEmpresaComponent, configuracionGlobal);

    modal.afterClosed().subscribe( data => {

      // console.log("==============data");
      // console.log(data);

      if (data != null) {

        vDenunciante = data;
        vPersona = new Persona();
        vPersona.listaPersonaPorReplegal = [];

        // vDenunciante.personaComplemento

        if (vDenunciante.cdenuncianteFlgsinruc == 'NO') {

          vPersona.cpersonaNrodoc = vDenunciante.personaComplemento.cpersonaNrodoc;
          vPersona.npersonaIdtipdoc = vDenunciante.personaComplemento.npersonaIdtipdoc;
          vPersona.npersonaId = vDenunciante.personaComplemento.npersonaId;

        }

        vPersona.cpersonaRazonsocial = vDenunciante.cdenuncianteDscagrup;
        vPersona.cpersonaCdepartdomic = vDenunciante.cdenuncianteCdepartcompl;
        vPersona.cpersonaCprovdomic = vDenunciante.cdenuncianteCprovcompl;
        vPersona.cpersonaCdistdomic = vDenunciante.cdenuncianteCdistcompl;
        vPersona.cpersonaDscdireccion = vDenunciante.cdenuncianteDscdirecccompl;
        vPersona.cpersonaDscreferencia = vDenunciante.cdenuncianteDscrefdomccompl;

        vDenunciante.listaDenunciantePorReplegal.forEach(element => {

          vPersonaXRL = new PersonaXRepLeg();

          if (!dscRepre) {

            dscRepre = element.cdciantexrlNombres;

          }

          vPersonaXRL.cpersonaxrlNombres = element.cdciantexrlNombres;

          vPersona.listaPersonaPorReplegal.push(vPersonaXRL);

        });

        vPersona.cpersonaDscreprelegal = dscRepre;

        this.empresaList.push(vPersona);

        this._cargarTableMaterial();

      }

    });

  }

  abrirModal(personaArg: Persona, flgValidaArg: boolean, listaEmpresaArg: Persona[]) {

    const configuracionGlobal = new MatDialogConfig();

    configuracionGlobal.disableClose = true;
    configuracionGlobal.autoFocus = true;

    configuracionGlobal.data = {
      cpersonaNrodoc: personaArg.cpersonaNrodoc,
      cpersonaRazonsocial: personaArg.cpersonaRazonsocial,
      cpersonaDscdireccion : personaArg.cpersonaDscdireccion,
      cpersonaDscreprelegal : personaArg.cpersonaDscreprelegal,
      flgValida: flgValidaArg,
      listaEmpresa: listaEmpresaArg
    };

    configuracionGlobal.width = '60%';

    const  modal = this.dialog.open(ModalEmpresaComponent, configuracionGlobal);

    modal.afterClosed().subscribe( data => {

          if (data != null) {
            this.flgDeshabilitaValidar = false;

            this.inputRazonSocial = '';
            this.inputRuc = '';
            this._cargarTableMaterial();
            // this.formEmpresaInvolucrada.get('empresa_registrada').setValue(false);

          }

          this.empresa_registrada = false;

        }

      );

  }

  _cambiarConoceEmpresa(e) {

    this.flgConoceEmpresa = e.checked;

  }


  cambiarEmpresaRegistada(evento) {

    // console.log(evento);

    if (evento.target.checked) {

      const persona  = new Persona();

      this.abrirModal(persona, false, this.empresaList);

    }

  }

  _eliminar(empresa) {

    openModalMensajePrg(this.strDscTitulo, strDscMsjPrgEliminar, this.dialog).subscribe(result => {

      // if(result != true)
      if (result == false) {

        this.empresaList.splice(this.empresaList.indexOf(empresa), 1);
        this._cargarTableMaterial();


      }

    });

  }

  rucSeleccionado(evento) {

    this.inputRazonSocial = '';
    this.flgRucDisabled = false;
    this.flgRazonSocialDisabled = true;
    console.log(this.cbk_empresa);
    // this.formEmpresaInvolucrada.get('input_razon_social').setValue('');
  }

  razonSeleccionado() {
    this.inputRuc = '';
    this.flgRazonSocialDisabled = false;
    this.flgRucDisabled = true;
    // this.formEmpresaInvolucrada.get('input_ruc').setValue('');
  }


  setEmpresaComponent(fur: Fur) {

    let vFlgConoceEmp = false;

    if (isNotEmptyList(fur.listaFurPorEmpresaInvolucrada)) {

      fur.listaFurPorEmpresaInvolucrada.forEach(empresa => {
        this.empresaList.push(empresa.persona);
      });

      // console.log("=========================fur.listaFurPorEmpresaInvolucrada");
      // console.log(fur.listaFurPorEmpresaInvolucrada);

      this._cargarTableMaterial();

      vFlgConoceEmp = true;

    }

    this.flgConoceEmpresa = vFlgConoceEmp;


  }

  empresaCReadEnable() {
    this.flgLectura = true;
    this.flgRazonSocialDisabled = true;
    this.flgRucDisabled = true;
  }

  empresaCReadDisable() {
    this.flgLectura = false;
    this.flgRazonSocialDisabled = false;
    this.flgRucDisabled = false;
  }

  _cargarTableMaterial() {

    setTimeout(() => {

      this.dataSource = new MatTableDataSource(this.empresaList);
      if (this.paginator != null) {
        this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;

      } // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
      // this.paginator._intl.itemsPerPageLabel = DscTituloPaginator;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    }, 1);


  }
}
